module.exports = __webpack_public_path__ + "assets/006e38d0323e2623de0112864af2553d.png";